import {
    Children,
    cloneElement,
    isValidElement,
    type ComponentPropsWithoutRef,
    type PropsWithChildren,
    type ReactElement,
} from 'react'

const TRIGGER_PROPS = {
    type: 'button',
    'aria-haspopup': 'menu',
    'aria-expanded': false,
    'data-state': 'closed',
} as const

export const MenuPlaceholder = ({ children }: PropsWithChildren) => children

type TMenuTriggerPlaceholderProps = ComponentPropsWithoutRef<'button'> & { asChild?: boolean }

export const MenuTriggerPlaceholder = ({
    children,
    asChild,
    ...props
}: TMenuTriggerPlaceholderProps) => {
    // Radix merges the trigger into its child; nesting a second button here would shift every
    // position after it and break hydration.
    if (asChild) {
        const child = Children.only(children)

        if (isValidElement(child)) {
            return cloneElement(child as ReactElement, { ...TRIGGER_PROPS, ...props })
        }
    }

    return (
        <button
            type="button"
            aria-haspopup="menu"
            aria-expanded={false}
            data-state="closed"
            {...props}
        >
            {children}
        </button>
    )
}
